<template>
    <div>
        <div class="d-flex-center py-5">
            <img
                src="@/assets/report/monthly.png">
        </div>
        <v-container>
            <v-row>
                <v-col
                    class="d-flex-center pb-0"
                    offset="4"
                    cols="4">
                    <div class="monthly-report-input">
                        <v-menu
                            v-model="monthPickerShow"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">

                            <template v-slot:activator="{ on }">
                                <v-text-field
                                        v-model="monthFormatted"
                                        :label="$vuetify.lang.t('$vuetify.monthly.monthly')"
                                        prepend-inner-icon="event"
                                        @click:prepend-inner="monthPickerShow = true"
                                        readonly
                                        v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                :locale="localeLang"
                                type="month"
                                v-model="monthPick"
                                @input="monthPickerShow = false"
                                :max="maxMonth"
                            ></v-date-picker>
                        </v-menu>
                    </div>
                </v-col>
                <v-col
                    class="d-flex-space-around pt-0"
                    offset="4"
                    cols="4">
                    <v-btn
                        color="red lighten-2"
                        class="ma-2 white--text"
                        width="180"
                        height="50"
                        :disabled="!canGenReport"
                        @click="submit(typePdf)">
                        {{ $vuetify.lang.t('$vuetify.monthly.exportPDF') }}
                    </v-btn>
                    <v-btn
                        color="green darken-1"
                        class="ma-2 white--text"
                        width="180"
                        height="50"
                        :disabled="!canGenReport"
                        @click="submit(typeExcel)">
                        {{ $vuetify.lang.t('$vuetify.monthly.exportExcel') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'Monthly',

    props: {
        canGenReport: {
            type: Boolean,
            default: false
        },
        branchId: {
            type: Number,
            default: null
        }
    },

    data () {
        return {
            monthPickerShow: false,
            monthPick: new Date().toISOString().substr(0, 7),
            maxMonth: new Date().toISOString().substr(0, 7),
            monthFormatted: this.monthFormat(new Date().toISOString().substr(0, 7)),
            typePdf: 'pdf',
            typeExcel: 'excel',
            exportPath: ''
        }
    },

    computed: {
        localeLang () {
            return this.$vuetify.lang.current
        }
    },

    methods: {
        monthFormat (monthly) {
            const [year, month] = monthly.split('-')
            const BEYear = parseInt(year) + 543
            return `${month}/${BEYear}`
        },

        async submit (reportType) {
            if (this.typePdf === reportType) {
                this.exportPath = 'report/monthly/pdf'
                if (this.branchId === 0) {
                    this.exportPath = `${this.exportPath}/branches`
                }
                await this.genPdfMonthlyReport()
            } else if (this.typeExcel === reportType) {
                this.exportPath = 'report/monthly/excel'
                if (this.branchId === 0) {
                    this.exportPath = `${this.exportPath}/branches`
                }
                await this.genExcelReport()
            }
        },

        async genPdfMonthlyReport () {
            this.$store.dispatch('setLoading', true)
            const [year, month] = this.monthPick.split('-')
            const response = await this.axios.post(this.exportPath, { year: parseInt(year), month: parseInt(month), branch_id: this.branchId }, {
                headers: {
                    'Content-Type': 'application/pdf'
                },
                responseType: 'arraybuffer'
            })

            if (response && response.data) {
                this.$util.downloadPdfFile(response.data)

                this.$store.dispatch('setLoading', false)
            }
        },

        async genExcelReport () {
            this.$store.dispatch('setLoading', true)
            const [year, month] = this.monthPick.split('-')
            const response = await this.axios.post(this.exportPath, { year: parseInt(year), month: parseInt(month), branch_id: this.branchId }, {
                headers: {
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                },
                responseType: 'arraybuffer'
            })

            if (response && response.data) {
                this.$util.downloadExcelFile(response.data, `report-${this.monthPick}.xls`)
                this.$store.dispatch('setLoading', false)
            }
        }
    },

    watch: {
        'monthPick' () {
            this.monthFormatted = this.monthFormat(this.monthPick)
        }
    }
}
</script>

<style lang="scss" scoped>
.space-between {
    display: flex;
    justify-content: space-between;
}
</style>
